export const DOMParser = window.DOMParser
